import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private snackBar: MatSnackBar) { }

  showSuccess(message: string): void {
    const defaultConfig: MatSnackBarConfig = {
      duration: 6000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['custom-toast-success'],
    };
    this.snackBar.open(message, "Dismiss", defaultConfig);
  }

  showError(message: string): void {
    const defaultConfig: MatSnackBarConfig = {
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['custom-toast-error'],
    };
    this.snackBar.open(message, "Dismiss", defaultConfig);
  }

  showWarning(message: string): void {
    const defaultConfig: MatSnackBarConfig = {
      duration: 6000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['custom-toast-warning'],
    };
    this.snackBar.open(message, "Dismiss", defaultConfig);
  }
}
